import { render } from "./ClientThirdStep.vue?vue&type=template&id=39b7e0a4&scoped=true"
import script from "./ClientThirdStep.vue?vue&type=script&lang=js"
export * from "./ClientThirdStep.vue?vue&type=script&lang=js"

import "./ClientThirdStep.vue?vue&type=style&index=0&id=39b7e0a4&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b7e0a4"]])

export default __exports__